module.exports = __webpack_public_path__ + "img/jer.a8ccc38.jpg";